/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Select, message, Drawer, DatePicker, Form } from 'antd'
import Checkbox from '../../components/Custom/CustomCheckbox'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import ContituentSelect from '../../components/Custom/ConstituentSelect'
import ConstituentAvatar from '../../components/Custom/ConstituentAvatar'
import ViewDetails from '../Certificates/modalDetails'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedConstituent: null,
			didSelectConstituent: false,
			isViewUserDetailsShown: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	componentDidMount() {
		const { selectedMedicalRecord } = this.props
		if (selectedMedicalRecord) {
			this.setState({ 
				selectedConstituent: { 
					uid: selectedMedicalRecord.constituent_uid,
					didSelectConstituent: false 
				}
			})
		}
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { selectedConstituent } = this.state
		const { history, form, AuthStore, saveMedicalRecord, onClose, isEdit, selectedMedicalRecord } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			// const complain_date = moment(values.complain_date).format('YYYY-MM-DD HH:mm:ss')
			let params = Object.assign({}, values, {
				barangay_uid
			})
			if (isEdit && selectedMedicalRecord) {
				params = Object.assign({}, params, { medical_record_uid: selectedMedicalRecord.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_medical_record', content: 'Saving Medical record, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveMedicalRecord(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_medical_record', content: 'Medical record successfully saved.' })

					if (isEdit && selectedMedicalRecord) {
						//create audit trail
						const auditParams = {
							module_name: 'Medical',
							action: 'Update',
							message: `Update medical record with case no ${selectedMedicalRecord.case_no}`
						}
						AuthStore.saveAuditTrail(auditParams)
					} else {
						//create audit trail
						const auditParams = {
							module_name: 'Medical',
							action: 'Create',
							message: 'Created new medical record'
						}
						AuthStore.saveAuditTrail(auditParams)
					}

					// const { uid } = response.data.setBlotter
					// history.push({ pathname: `/blotter/details/${uid}` })
					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving medical record')
					message.error({ key: 'set_medical_record', content: err.message.replace('GraphQL error:', '') })
					// resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, selectedMedicalRecord, AuthStore } = this.props
		const { getFieldDecorator, getFieldValue } = form
		const { barangay_uid } = AuthStore
		const { selectedConstituent, isViewUserDetailsShown } = this.state
        
		return (
			<Drawer
				title="New Medical Record"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'75%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					{
						selectedConstituent &&
						<Row style={{ marginBottom: 20 }}>
							<Row type='flex' justify='center'>
								<ConstituentAvatar size={100}  constituent_uid={selectedConstituent.uid}/>
							</Row>
							<Row style={{ textAlign: 'center' }}>
								<h4>{selectedConstituent.first_name} {selectedConstituent.middle_name} {selectedConstituent.last_name}</h4><br />
								<a href='javascript:void(0)' onClick={() => this.setState({ isViewUserDetailsShown: true })}>View Details</a>
							</Row>
						</Row>
					}
					<Row gutter={16}>
						<Col md={12} sm={24}>
							<Form.Item label='Constituent'>
								{ getFieldDecorator('constituent_uid', {
									initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.constituent_uid : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<ContituentSelect 
										barangay_uid={barangay_uid}
										placeholder='Select constituent name'
										onSelectedItem={(item) => {
											if (item) {
												this.setState({ selectedConstituent: Object.assign({}, item, { didSelectConstituent: true }) })
											} else {
												this.setState({ selectedConstituent: null })
											}
										}}
									/>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Philhealth Number'>
								{ getFieldDecorator('philhealth_number', {
									initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.philhealth_number : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Philhealth number' />
								)}
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col md={8} sm={24}>
							<Form.Item label='Ref. From'>
								{ getFieldDecorator('refer_from', {
									initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.refer_from : 'Camacho Health Center',
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Ref. from' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Ref. To'>
								{ getFieldDecorator('refer_to', {
									initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.refer_to : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Ref. To' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Date/Time Referred'>
								{ getFieldDecorator('refer_date', {
									initialValue: (selectedMedicalRecord) ? moment(selectedMedicalRecord.refer_date) : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<DatePicker format='LLL' showTime style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<legend>Subjective Complaints</legend>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('cough', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.cough, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>cough</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('colds', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.colds, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>colds</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('fever', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.fever, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>fever</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('vomiting', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.vomiting, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>vomiting</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={4} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('abdomen_pain', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.abdomen_pain, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>abdomen pain</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={4} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('bowel_movement', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.bowel_movement, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>bowel movement</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('urine', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.urine, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>urine</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('ear_pain', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.ear_pain, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>ear pain</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('is_other_complaint', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.is_other_complaint, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>others:</Checkbox>
								)}
							</Form.Item>
						</Col>
						{
							getFieldValue('is_other_complaint') &&
							<Col md={16} sm={24}>
								<Form.Item label=''>
									{ getFieldDecorator('other_complaints', {
										initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.other_complaints : null,
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Enter other complaint' />
									)}
								</Form.Item>
							</Col>
						}
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('allergic', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.allergic, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>allergies:</Checkbox>
								)}
							</Form.Item>
						</Col>
						{
							getFieldValue('allergic') &&
							<Col md={16} sm={24}>
								<Form.Item label=''>
									{ getFieldDecorator('allergies', {
										initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.allergies : null,
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Enter allergies' />
									)}
								</Form.Item>
							</Col>
						}
					</Row>
					<Row gutter={16}>
						<Col md={24} sm={24}>
							<Form.Item label='Meds taken:'>
								{ getFieldDecorator('medicine_taken', {
									initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.medicine_taken : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter medicine taken' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Weight'>
								{ getFieldDecorator('weight', {
									initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.weight : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter weight' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Height'>
								{ getFieldDecorator('height', {
									initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.height : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter height' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Blood Pressure'>
								{ getFieldDecorator('blood_pressure', {
									initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.blood_pressure : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter blood pressure' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='CR/PR'>
								{ getFieldDecorator('cp_pr', {
									initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.cp_pr : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter CR/PR' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Respiratory Rate'>
								{ getFieldDecorator('respiratory_rate', {
									initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.respiratory_rate : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter respiratory rate' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Temperature'>
								{ getFieldDecorator('temperature', {
									initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.temperature : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter temperature' />
								)}
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<legend>Objective Findings</legend>
						<Col md={4} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('fast_breathing', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.fast_breathing, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>Fast breathing</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('rales', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.rales, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>rales</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('wheezes', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.wheezes, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>wheezes</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('rashes', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.rashes, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>rashes</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={4} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('chest_indrawing', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.chest_indrawing, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>Chest indrawing</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('is_other_findings', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.is_other_findings, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>others:</Checkbox>
								)}
							</Form.Item>
						</Col>
						{
							getFieldValue('is_other_findings') &&
							<Col md={24} sm={24}>
								<Form.Item label=''>
									{ getFieldDecorator('other_findings', {
										initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.other_findings : null,
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Enter other findings' />
									)}
								</Form.Item>
							</Col>
						}
					</Row>
					<Row gutter={16}>
						<legend>Assessment</legend>
						<Col md={4} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('water', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.water, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>Water - 3 Liters/day</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('more_fibers', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.more_fibers, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>More fibers</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={4} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('less_salt', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.less_salt, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>Less salt, fat, oils</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={3} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('immunization', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.immunization, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>Immunization</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={4} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('vitamin_a', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.vitamin_a, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>Vitamin A</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('slk', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.slk, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>{`(SLK) Sampalok Luya Kalamansi`}</Checkbox>
								)}
							</Form.Item>
						</Col>
						<Col md={4} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('follow_up', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.follow_up, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>Follow-up after</Checkbox>
								)}
							</Form.Item>
						</Col>
						{
							getFieldValue('follow_up') &&
							<Col md={8} sm={24}>
								<Form.Item label=''>
									{ getFieldDecorator('follow_up_details', {
										initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.follow_up_details : null,
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Enter follow-up details' />
									)}
								</Form.Item>
							</Col>
						}
						<Col md={4} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('balik_agad', {
									initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.balik_agad, 1)) ? true : false,
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>Balik kaagad kung:</Checkbox>
								)}
							</Form.Item>
						</Col>
						{
							getFieldValue('balik_agad') &&
							<Col md={4} sm={24}>
								<Form.Item label=''>
									{ getFieldDecorator('stop_smoking', {
										initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.stop_smoking, 1)) ? true : false,
										rules: [{
											required: false,
											message: 'This field is required.'
										}]
									})
									(
										<Checkbox>STOP SMOKING</Checkbox>
									)}
								</Form.Item>
							</Col>
						}
						{
							getFieldValue('balik_agad') &&
							<Col md={6} sm={24}>
								<Form.Item label=''>
									{ getFieldDecorator('stop_secondhand_smoking', {
										initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.stop_secondhand_smoking, 1)) ? true : false,
										rules: [{
											required: false,
											message: 'This field is required.'
										}]
									})
									(
										<Checkbox>STOP 2nd HAND SMOKING</Checkbox>
									)}
								</Form.Item>
							</Col>
						}
						{
							getFieldValue('balik_agad') &&
							<Col md={6} sm={24}>
								<Form.Item label=''>
									{ getFieldDecorator('exercise', {
										initialValue: (selectedMedicalRecord && _.isEqual(selectedMedicalRecord.exercise, 1)) ? true : false,
										rules: [{
											required: false,
											message: 'This field is required.'
										}]
									})
									(
										<Checkbox>Exercise 3 times a week</Checkbox>
									)}
								</Form.Item>
							</Col>
						}
						<Col md={24} sm={24}>
							<Form.Item label=''>
								{ getFieldDecorator('prescription', {
									initialValue: (selectedMedicalRecord) ? selectedMedicalRecord.prescription : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input.TextArea rows={8} placeholder='Enter meds/ doctor prescription' />
								)}
							</Form.Item>
						</Col>
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>

				{
					isViewUserDetailsShown &&
					<ViewDetails 
						// table_name={table_name}
						constituent_uid={selectedConstituent.uid}
						visible={isViewUserDetailsShown}
						onCancel={() => this.setState({ isViewUserDetailsShown: false })}
					/>
				}
			</Drawer>
		)
	}
}

const SET_MEDICAL_RECORD = gql`
    mutation setMedicalRecord($input: JSON) {
		setMedicalRecord(input: $input)
    }
`

const composed = compose(
	withRouter,
	Form.create({ name: 'form-medical-record' }),
	inject('AuthStore'),
	graphql(SET_MEDICAL_RECORD, {
		props({ mutate }) {
			return {
				saveMedicalRecord(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['medicalRecords']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
